export type ClipWindow={leadingMs:number;trailingMs:number};
export function playableSeconds(duration:number,window:ClipWindow){return Math.max(0,duration-(window.leadingMs+window.trailingMs)/1000);}
export function wholeDialogueProgress(durations:number[],index:number,time:number,windows:ClipWindow[]){
 const lengths=durations.map((d,i)=>playableSeconds(d,windows[i]!)),total=lengths.reduce((a,b)=>a+b,0);
 if(!total)return 0;
 return Math.max(0,Math.min(1,(lengths.slice(0,index).reduce((a,b)=>a+b,0)+Math.max(0,Math.min(lengths[index]??0,time-(windows[index]?.leadingMs??0)/1000)))/total));
}
/** One playback clock. Gaps and pauses do not consume line audio progress. */
export class DialogueProgressPlayer{
 private nodes:HTMLAudioElement[]=[];private frame=0;private stopped=false;private paused=false;private index=0;
 private abort=new AbortController();private resumeWait:(()=>void)|null=null;
 constructor(private urls:string[],private windows:ClipWindow[],private gapMs:number,private state:(s:string)=>void,private progress:(p:number)=>void){}
 pause(){this.paused=true;this.nodes[this.index]?.pause();this.state('paused');}
 resume(){this.paused=false;this.state('playing');this.resumeWait?.();this.resumeWait=null;}
 stop(){this.stopped=true;this.abort.abort();this.nodes.forEach(n=>{n.pause();n.removeAttribute('src');n.load();});cancelAnimationFrame(this.frame);this.resumeWait?.();this.resumeWait=null;}
 private async waitForResume(){if(this.paused&&!this.stopped)await new Promise<void>(r=>{this.resumeWait=r;});}
 async play(){
  this.state('loading');this.progress(0);
  try{
   this.nodes=this.urls.map(url=>{const n=new Audio();n.preload='metadata';n.src=url;return n;});
   await Promise.all(this.nodes.map(n=>new Promise<void>((resolve,reject)=>{
    if(n.readyState>=1&&Number.isFinite(n.duration)&&n.duration>0){resolve();return;}
    n.addEventListener('loadedmetadata',()=>Number.isFinite(n.duration)&&n.duration>0?resolve():reject(Error('duration')),{once:true,signal:this.abort.signal});
    n.addEventListener('error',()=>reject(Error('unavailable')),{once:true,signal:this.abort.signal});
    this.abort.signal.addEventListener('abort',()=>reject(Error('cancelled')),{once:true});n.load();
   })));
   if(this.stopped)return;
   const durations=this.nodes.map(n=>n.duration);
   const tick=()=>{if(this.stopped)return;if(!this.paused)this.progress(wholeDialogueProgress(durations,this.index,this.nodes[this.index]?.currentTime??0,this.windows));this.frame=requestAnimationFrame(tick);};tick();
   for(this.index=0;this.index<this.nodes.length;this.index++){
    if(this.stopped)return;await this.waitForResume();if(this.stopped)return;
    const n=this.nodes[this.index]!,w=this.windows[this.index]!;n.currentTime=Math.min(n.duration,w.leadingMs/1000);
    await new Promise<void>((resolve,reject)=>{
     let timer:number;const finish=()=>{clearInterval(timer);n.pause();resolve();};
     n.onended=finish;n.onerror=()=>{clearInterval(timer);reject(Error('unavailable'));};
     this.abort.signal.addEventListener('abort',finish,{once:true});
     timer=window.setInterval(()=>{if(this.stopped){finish();return;}if(!this.paused&&n.currentTime>=n.duration-w.trailingMs/1000)finish();else if(!this.paused&&n.paused)n.play().catch(reject);},20);
     this.state('playing');n.play().catch(reject);
    });
    if(this.stopped)return;
    if(this.index+1<this.nodes.length){let remaining=this.gapMs,last=performance.now();while(remaining>0&&!this.stopped){await new Promise(r=>setTimeout(r,20));const now=performance.now();if(!this.paused)remaining-=now-last;last=now;}}
   }
   if(!this.stopped){this.progress(0);this.state('idle');}
  }catch{if(!this.stopped){this.progress(0);this.state('error');}}
  finally{this.stop();}
 }
}
